import React, { Component } from 'react';
import { connect} from "remx";
import { Modal } from "react-bootstrap"

import authStore from '../stores/auth'
import dataStore from '../stores/data'
import broker from '../utils/broker';

import '../assets/css/dashforge.landing.css';
import 'react-toastify/dist/ReactToastify.css';

import Topbar from './_layout/Topbar';
import {Routes} from '../helpers/routes';
import LoginLayout from './LoginLayout';
import NavbarRight from './_layout/NavbarRight';


class MainLayout extends Component {

    constructor(props) {
        super(props);

        this.options = {
            
        }
        this.state = {
            user: this.props.user,
            page : '',
            scriptLoaded : null,
            scriptKey : 0,
            key : Math.random(),
            old_password: '',
            new_password: '',
            confirm_password : '',
            password_not_match: '',
        }
        // preserve the initial state in a new object
        this.baseState = this.state;
        this.handleChange = this.handleChange.bind(this);
        this.changePassword = this.changePassword.bind(this);
    }

    UNSAFE_componentWillReceiveProps (newProps) {
        if(newProps.user) {
            this.setState({
              user: newProps.user
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.user !== prevProps.user){
            this.setState({user : this.props.user})
            if (this.props.user) {

            } 
        }
    }

    handleChange(event) {
        var id = event.target.id;
        this.setState({[id]: event.target.value}, function(){
            if (this.state.new_password !== this.state.confirm_password && this.state.new_password !== '' && this.state.confirm_password !== ''){
                this.setState({password_not_match : 'password confirmation not match'})
            } else {
                this.setState({password_not_match : ''})
            }
        });



    }

    changePassword(){
        var body = {
                        password_old : this.state.old_password, 
                        password : this.state.new_password, 
                        password_confirmation: this.state.confirm_password
                    }

    broker.fetch.post(`/auth/change_password`, body)
        .then(res => {
            const { data } = res.data;
            if (data) {
                dataStore.setters.setChangePassword(false);
                dataStore.setters.setReloadTable(true);
            } else {

            }
        }).catch(err => {
            
    });
        
    }


    render(){
        const token = window.localStorage.getItem('token');
        const token_support = window.localStorage.getItem('token_support');
        if (!this.state.user && !token && !token_support) {
            return (<LoginLayout />)
        } else {
            if (this.state.user && token && token_support) {
                return(
                    <div className="App">
                        <header className="navbar navbar-header navbar-header-fixed">
                            <Topbar />
                            <NavbarRight />
                        </header>
                        <Routes user={this.state.user}/>      
                        <Modal show={this.props.change_password} onHide={() => dataStore.setters.setChangePassword(false)} animation={false}>
                            <Modal.Header closeButton>
                            <Modal.Title>Change Password</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                            <div className="form-group row">
                                <label className="col-sm-4 col-form-label">Old Password</label>
                                <div className="col-sm-8">
                                    <input type="password" value={this.state.old_password} id="old_password" onChange={this.handleChange} className="form-control" placeholder="Old Password" />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-4 col-form-label">New Password</label>
                                <div className="col-sm-8">
                                    <input type="password" className="form-control" value={this.state.new_password} id="new_password" onChange={this.handleChange} placeholder="New Password" />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-4 col-form-label">Confirm Password</label>
                                <div className="col-sm-8">
                                    <input type="password" className="form-control" value={this.state.confirm_password} id="confirm_password" onChange={this.handleChange} placeholder="Confirm Password" />
                                </div>
                            </div>
                            <div className="text-danger">{this.state.password_not_match}</div>
                            </Modal.Body>
                            <Modal.Footer>
                                <button className="btn btn-white" type="button" onClick={() => dataStore.setters.setChangePassword(false)}>Cancel</button>
                                <button className="btn btn-primary btn-sm" type="button" onClick={()=> this.changePassword()}>Change Password</button>
                            </Modal.Footer>
                        </Modal>            
                    </div>
                );    
            } else {
                return null
            }
        }
        
    }

}

function mapStateToProps(props) {
    return {
        user: authStore.getters.getUser(),
        change_password : dataStore.getters.getChangePassword()
    }
}

export default connect(mapStateToProps)(MainLayout);
